import React, { FC, useState } from 'react';
import { Dialog, DialogContent, Button, Grid, makeStyles, Theme, Typography, DialogActions, CircularProgress } from '@material-ui/core';
import { DialogTitle } from 'components/Dialog';
import { BLACK, YELLOW } from 'constants/colors';
import { WarningRounded, CloudDownloadRounded } from '@material-ui/icons';
import { format } from 'date-fns';
import NumberFormat from 'components/NumberFormat';

interface Props {
  open: boolean;
  isLoading: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
  handleReject: () => void;
  invoicePayment?: InvoicePaymentModel;
}

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    borderRadius: '15px',
    padding: '7px 0'
  },

  titleContainer: {
    fontWeight: 500,
    fontSize: '1.2rem',
    color: BLACK,
    paddingLeft: '6px'
  },
  containerContent: {
    [theme.breakpoints.up('md')]: {
      // width: '70vh'
    }
  },
  containerAction: {
    marginBottom: theme.spacing(1)
  },
  spacing: {
    marginTop: theme.spacing(2)
  },
  paymentImages: {
    objectFit: 'contain',
    width: '100%',
    height: 'auto',
    marginBottom: theme.spacing(1)
  },
  containerDownloadAction: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '0.5em',
    marginBottom: '0.5em'
  },
  imageSection: {
    marginTop: theme.spacing(2)
  }
}));

const InvoicePaymentAuthorization = ({ handleReject, open, handleClose, handleSubmit, isLoading, invoicePayment }: Props) => {
  const classes = useStyles();
  const isBankTransfer = invoicePayment?.paymentMethod?.toLowerCase() === 'bank transfer';

  const handleDownload = async (url: string, filename: string) => {
    try {
      const res = await fetch(url, { mode: 'cors', credentials: 'include' });
      if (!res.ok) throw new Error('Network response was not ok');
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error('Download failed:', err);
      // fallback: buka tab baru
      window.open(url, '_blank');
    }
  };

  console.log('invoicePayment -->', invoicePayment);

  return (
    <Dialog open={open} onClose={handleClose} scroll='paper'>
      <DialogTitle>
        <Grid item container direction='column' alignItems='center' xs={12}>
          <WarningRounded style={{ color: YELLOW, fontSize: '3rem' }} />
          <Typography className={classes.titleContainer}>Autorisasi Pembayaran Penjualan</Typography>
        </Grid>
      </DialogTitle>
      <DialogContent className={classes.containerContent}>
        <Typography align='center' style={{ fontSize: '1rem' }}>
          Apakah kamu yakin ingin autorisasi
          <br /> pembayaran penjualan ini?
        </Typography>

        {invoicePayment?.paymentMethod === 'Giro' && (
          <Grid item container direction='column' alignItems='center' style={{ marginTop: 16 }}>
            <Grid item>
              <Typography align='center' variant='h6'>
                Tanggal Jatuh Tempo
              </Typography>
              <Typography align='center' style={{ fontSize: '1rem' }}>
                {invoicePayment?.giroDueDate ? format(new Date(invoicePayment.giroDueDate as Date | string), 'dd MMM yyyy') : '-'}
              </Typography>
            </Grid>
            <Grid item>
              <Typography align='center' variant='h6'>
                Bank Giro
              </Typography>
              <Typography align='center' style={{ fontSize: '1rem' }}>
                {invoicePayment?.giroBank || '-'} - {invoicePayment?.giroNumber || '-'}
              </Typography>
            </Grid>
            <Grid item>
              <Typography align='center' variant='h6'>
                Total Giro
              </Typography>
              <Typography align='center' style={{ fontSize: '1rem' }}>
                {/* {invoicePayment?.totalPay ? `Rp ${invoicePayment?.totalPay}` : '-'} */}
                <NumberFormat value={invoicePayment.giroAmount} prefix={'Rp '} thousandSeparator={true} displayType='text' />
              </Typography>
            </Grid>
          </Grid>
        )}

        {isBankTransfer && (
          <Grid item container direction='column' alignItems='center' style={{ marginTop: 16 }}>
            <Grid item>
              <Typography align='center' variant='h6'>
                Tanggal Transfer
              </Typography>
              <Typography align='center' style={{ fontSize: '1rem' }}>
                {/* {invoicePayment?.transferDate ? `${invoicePayment?.transferDate}` : '-'} */}
                {invoicePayment?.transferDate
                  ? format(new Date(invoicePayment.transferDate as Date | string), 'dd MMM yyyy')
                  : invoicePayment?.payDate
                  ? format(new Date(invoicePayment.payDate as Date | string), 'dd MMM yyyy')
                  : '-'}
              </Typography>
            </Grid>
            <Grid item>
              <Typography align='center' variant='h6'>
                Bank Transfer
              </Typography>
              <Typography align='center' style={{ fontSize: '1rem' }}>
                {invoicePayment?.Bank?.bankAccount || '-'} - {invoicePayment?.Bank?.bankName || '-'} - {invoicePayment?.Bank?.bankNumber || '-'}
              </Typography>
            </Grid>
            <Grid item>
              <Typography align='center' variant='h6'>
                Total Bayar
              </Typography>
              <Typography align='center' style={{ fontSize: '1rem' }}>
                <NumberFormat value={invoicePayment?.totalPay || 0} prefix={'Rp'} thousandSeparator={true} displayType='text' />
              </Typography>
            </Grid>
          </Grid>
        )}

        {isBankTransfer && invoicePayment?.InvoicePaymentImages && invoicePayment.InvoicePaymentImages.length > 0 && (
          <div className={classes.imageSection}>
            <Typography variant='h6' align='left' style={{ marginBottom: 8 }}>
              Bukti Transfer
            </Typography>
            {invoicePayment.InvoicePaymentImages.map((val, key) => (
              <Grid container key={key} style={{ marginBottom: 16 }}>
                <Grid item xs={12}>
                  <img src={val.url} alt={`image payment ${key}`} loading='lazy' className={classes.paymentImages} />
                  <Typography variant='body2' className={classes.containerDownloadAction}>
                    <CloudDownloadRounded color='primary' />
                    <span
                      style={{ color: '#1976d2', textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={() => handleDownload(val.url, 'Bukti Transfer.jpg')}
                    >
                      Download Gambar
                    </span>
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </div>
        )}
      </DialogContent>
      <DialogActions className={classes.containerAction}>
        <Grid item container direction='row' justify='space-evenly' spacing={1} alignItems='center'>
          <Grid item xs={4}>
            <Button size='small' fullWidth className={classes.button} variant='text' onClick={handleClose}>
              Kembali
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button size='small' fullWidth className={classes.button} variant='outlined' onClick={handleReject}>
              Tolak
            </Button>
          </Grid>

          <Grid item xs={4}>
            <Button size='small' fullWidth disabled={isLoading} className={classes.button} color='primary' onClick={handleSubmit}>
              {isLoading ? <CircularProgress color='primary' size={20} /> : 'Autorisasi'}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default InvoicePaymentAuthorization;
